__turbopack_context__.v({
  "controls": "EditFormMobileControls-module-scss-module__KulR-W__controls",
  "mobileCloseButton": "EditFormMobileControls-module-scss-module__KulR-W__mobileCloseButton",
  "primaryButton": "EditFormMobileControls-module-scss-module__KulR-W__primaryButton",
  "root": "EditFormMobileControls-module-scss-module__KulR-W__root",
  "secondaryButton": "EditFormMobileControls-module-scss-module__KulR-W__secondaryButton",
  "title": "EditFormMobileControls-module-scss-module__KulR-W__title",
  "visible": "EditFormMobileControls-module-scss-module__KulR-W__visible",
});
